// import Vue from "vue";
import ajax from "../../plugins/ajax_request";

const state = () => ({
  cartRows: [],
  configurations: [],
  checkoutSuccess: false,
  checkingOut: false,
});

const getters = {
  canAddToCart: (state, getters, rootState, rootGetters) => {
    let guest = rootGetters["user/userIsGuest"];
    let configurationComplete = rootGetters.configurationComplete;
    if (configurationComplete && !guest) {
      return true;
    } else {
      return false;
    }
  },
  // eslint-disable-next-line no-unused-vars
  rowNumber: (state, getters, rootState, rootGetters) => {
    return state.cartRows.length;
  },
};

const mutations = {
  setCartRows(state, rows) {
    state.cartRows = rows;
  },
  /*Cart mutations*/

  emptyCart: (state) => {
    state.cartRows = [];
  },
  setCheckoutStatus: (state, status) => {
    state.checkoutSuccess = status;
  },
  setCheckingOut: (state, s) => {
    state.checkingOut = s;
  },
};

const actions = {
  // eslint-disable-next-line no-unused-vars
  addToCart({ commit, state, rootState }) {
    let rows = [];
    let row = {
      ItemCode: rootState.frontale.ItemCode,
      colore_frontale: rootState.colore.U_THE_COLORE,
      quantita: 1,
      note: rootState.note,
      TempleCode: rootState.coloreAste.ItemCode,
      FinishingTemple: rootState.finituraAste,
      calibro: rootState.calibro,
      naso: rootState.naso,
      finishing: rootState.finitura,
      asian_fitting: rootState.asianFitting ? 1 : 0,
      colore_nome:
        rootState.nome && rootState.nome.length > 0 ? rootState.coloreNome : "",
      coloreNomeExtAstaSx:
        rootState.nomeExtAstaSx && rootState.nomeExtAstaSx.length > 0
          ? rootState.coloreNomeExtAstaSx
          : "",
      coloreNomeIntAstaSx:
        rootState.nomeIntAstaSx && rootState.nomeIntAstaSx.length > 0
          ? rootState.coloreNomeIntAstaSx
          : "",
      coloreNomeExtAstaDx:
        rootState.nomeExtAstaDx && rootState.nomeExtAstaDx.length > 0
          ? rootState.coloreNomeExtAstaDx
          : "",
      coloreNomeIntAstaDx:
        rootState.nomeIntAstaDx && rootState.nomeIntAstaDx.length > 0
          ? rootState.coloreNomeIntAstaDx
          : "",
      // font_nome: "",
      font_nome:
        rootState.nome && rootState.nome.length > 0
          ? rootState.fontNome
          : "Batang",
      fontNomeExtAstaSx:
        rootState.nomeExtAstaSx && rootState.nomeExtAstaSx.length > 0
          ? rootState.fontNomeExtAstaSx
          : "Batang",
      fontNomeIntAstaSx:
        rootState.nomeIntAstaSx && rootState.nomeIntAstaSx.length > 0
          ? rootState.fontNomeIntAstaSx
          : "Batang",
      fontNomeExtAstaDx:
        rootState.nomeExtAstaDx && rootState.nomeExtAstaDx.length > 0
          ? rootState.fontNomeExtAstaDx
          : "Batang",
      fontNomeIntAstaDx:
        rootState.nomeIntAstaDx && rootState.nomeIntAstaDx.length > 0
          ? rootState.fontNomeIntAstaDx
          : "Batang",
      nome: rootState.nome,
      nomeExtAstaSx: rootState.nomeExtAstaSx,
      nomeIntAstaSx: rootState.nomeIntAstaSx,
      nomeExtAstaDx: rootState.nomeExtAstaDx,
      nomeIntAstaDx: rootState.nomeIntAstaDx,
      coloreMetalloAste: rootState.coloreMetalloAste,
      // quantita: rootState.quantity,
    };
    rows.push(row);
    rootState.note = "";
    return ajax.addToCart(rows).then((response) => {
      let d = response.data;
      if (d.status.success) {
        // let gtagItems = [];
        // rows.forEach((row) => {
        //   let i = state.frontali.filter((frontale) => {
        //     return frontale.ItemCode == row.ItemCode;
        //   })[0];
        //   let temp = {
        //     id: i.ItemCode,
        //     name: i.ItemName,
        //     brand: i.U_THE_LINEA,
        //     variant: `${i.U_THE_MODELLO} ${row.calibro}/${row.naso} ${row.colore_frontale} - ${row.finishing}`,
        //     quantity: row.quantita,
        //     price: i.PRICE,
        //     aste: state.coloreAste.ItemName,
        //     coloreMetalloAste: state.coloreMetalloAste,
        //     finitura: state.finitura == "S" ? "LUCIDO" : "OPACO",
        //     asianFitting: state.asianFitting ? "SI" : "NO",
        //     coloreFrontale: row.colore_frontale,
        //     misura: `${row.calibro}/${row.naso}`,
        //     finituraAste: state.finituraAste == "S" ? "LUCIDO" : "OPACO",
        //     nomePersonalizzato: state.nome,
        //     coloreNomePersonalizzato: state.coloreNome,
        //   };
        //   gtagItems.push(temp);
        // });
        // gtag("event", "add_to_cart", { items: gtagItems });

        rootState.nome = "";
        rootState.fontNome = "Batang";
        rootState.coloreNome = "nessun-colore";
        rootState.nomeExtAstaSx = "";
        rootState.fontNomeIntAstaSx = "Batang";
        rootState.coloreNomeExtAstaSx = "nessun-colore";
        rootState.nomeIntAstaSx = "";
        rootState.fontNomeExtAstaSx = "Batang";
        rootState.coloreNomeIntAstaSx = "nessun-colore";
        rootState.nomeExtAstaDx = "";
        rootState.fontNomeIntAstaDx = "Batang";
        rootState.coloreNomeExtAstaDx = "nessun-colore";
        rootState.nomeIntAstaDx = "";
        rootState.fontNomeExtAstaDx = "Batang";
        rootState.coloreNomeIntAstaDx = "nessun-colore";
        commit("setCartRows", d.cart); //status.cartRows = d.cart;
      }
    });
  },
  addSampleToCart({ commit, state }, rows) {
    // let auth_key = Vue.$cookies.get("_identity");
    return ajax.addToCart(rows).then((response) => {
      let d = response.data;
      if (d.status.success) {
        state.nome = "";
        state.coloreNome = "";
        commit("setCartRows", d.cart); //status.cartRows = d.cart;
      }
    });
  },
  deleteCartRow(commit, id) {
    // let auth_key = Vue.$cookies.get("_identity");
    ajax.deleteCartRow(id).then((response) => {
      let d = response.data;
      if (d.status == true) {
        commit("setCartRows", d.cart); //status.cartRows = d.cart;
      }
    });
  },
  emptyCart(commit) {
    ajax.emptyUserCart().then((response) => {
      let d = response.data;
      if (d == true) {
        commit("emptyCart");
      }
    });
  },
  checkout(commit, note) {
    ajax.checkout(note).then((response) => {
      let d = response.data;
      if (parseInt(d.order_id) > 0) {
        commit("setCheckoutStatus", true);
        commit("setCheckingOut", false);
        commit("emptyCart");
      } else {
        commit("setCheckoutStatus", false);
      }
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
